import React from 'react'

import { Card, Icon, Skeleton, Button } from 'antd'
import PT from 'prop-types'

import SimpleBar from '../../../../../../components/charts/SimpleBar'
import { toTestId } from '../../../../../../utils/testing'

const { Meta } = Card
const headingStyles = { marginBottom: 0 }

const BarFilters = ({
  data,
  description,
  disabled,
  isSalary,
  maxHeight,
  onBarClick,
  onClearFilter,
  listTestId,
  selectedValue,
  title,
}) => {
  const actionText = selectedValue ? 'Clear' : 'Filter'
  const titleId = title
    ? `bar-filter-title-${title.toLowerCase().replace(/[^a-z0-9]+/g, '-')}`
    : undefined

  return (
    <div data-testid="click-filter-category">
      <div style={{ margin: '0 auto', maxWidth: 350 }}>
        {!disabled && (
          <Button
            type="link"
            className="bar-icon"
            onClick={() => onClearFilter()}
            aria-label={`${actionText} ${title} filter`}
            title={`${actionText} ${title} filter`}
            style={{ border: 'none', height: 'auto', padding: 0 }}
          >
            <Icon
              type={selectedValue ? 'close-circle' : 'filter'}
              theme="twoTone"
              twoToneColor={selectedValue ? '#eb2f96' : ''}
              aria-hidden="true"
            />{' '}
            {actionText}
          </Button>
        )}
        {title && (
          <Meta
            title={
              <h3 id={titleId} style={headingStyles}>
                {title}
              </h3>
            }
            description={description}
          />
        )}
        <Skeleton
          loading={!(data && !!data.length)}
          paragraph={{
            rows: 8,
            width: ['90%', '80%', '70%', '60%', '50%', '40%', '30%', '20%'],
          }}
          title={false}
        >
          <SimpleBar
            data={data}
            disabled={!!disabled}
            isSalary={isSalary}
            onBarClick={onBarClick}
            selectedValue={selectedValue}
            maxHeight={maxHeight}
            ariaLabelledBy={titleId}
            barColor=""
            dataTestId={listTestId || (title ? `${toTestId(title)}-list` : undefined)}
          />
        </Skeleton>
      </div>
    </div>
  )
}

BarFilters.propTypes = {
  data: PT.array.isRequired,
  description: PT.string,
  disabled: PT.bool,
  isSalary: PT.bool,
  listTestId: PT.string,
  maxHeight: PT.number,
  onBarClick: PT.func,
  onClearFilter: PT.func,
  selectedValue: PT.string,
  title: PT.string.isRequired,
}

export default BarFilters
